// extracted by mini-css-extract-plugin
module.exports = {"root":"FlexibleImageCTA_root__2DB0e","ctaContent":"FlexibleImageCTA_ctaContent__38mD2","header":"FlexibleImageCTA_header__EVMvH","cta":"FlexibleImageCTA_cta__jQgUc"};